import { Form, Radio } from "antd";
import { IoIosArrowBack } from "react-icons/io";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import {
  LocationSVG,
  NextArrowSVG,
  NoLocationSVG,
} from "../../../assets/onboarding/SVGs";
import { updateStep25 } from "../../../services/store/slices/onboarding";

const Step25 = ({ nextStep, data, updateData }: any) => {
  const user = useSelector((state: any) => state?.user);
  const dispatch = useDispatch();
  const intl = useIntl();
  const onFinish = (values: any) => {
    dispatch(updateStep25(values));
    nextStep();
  };
  return (
    <Form
      name="step25"
      onFinish={onFinish}
      layout={"vertical"}
      dir="rtl"
      initialValues={{}}
      className="w-full"
    >
      <div className="flex flex-col items-center justify-center w-full gap-6 pt-4 text-center">
        <h3 className="text-lg font-semibold text-color-primary">
          {intl.formatMessage({ id: "step25.title" })}
        </h3>
        <p className="text-base text-[#75757E] font-normal">
          {intl.formatMessage({ id: "step25.subtitle" })}
        </p>
      </div>
      <Form.Item
        name="type"
        className="!p-0 mx-auto flex items-center justify-center w-full"
        rules={[{ required: true, message: "اختار" }]}
        required={false}
        hasFeedback
      >
        <Radio.Group className="flex items-center justify-center w-full pb-4 mt-6 max-lg:flex-col">
          <Radio.Button
            value={"freelancer"}
            className="rounded-lg !m-4 border-solid border-[1px] !min-h-[65px] flex items-center justify-center text-center w-full"
          >
            <div className="flex items-center justify-center gap-3">
              <span className="flex items-center justify-center">
                {NoLocationSVG}
              </span>
              <span className="text-base font-medium">
                {intl.formatMessage({ id: "step25.option.freelancer" })}
              </span>
              <span className="flex items-center justify-center">
                {NextArrowSVG}
              </span>
            </div>
          </Radio.Button>
          <Radio.Button
            value={"onsite"}
            className="rounded-lg !m-4 border-solid border-[1px] !min-h-[65px] flex items-center justify-center text-center w-full"
          >
            <div className="flex items-center justify-center gap-3">
              <span className="flex items-center justify-center">
                {LocationSVG}
              </span>
              <span className="text-base font-medium">
                {intl.formatMessage({ id: "step25.option.onsite" })}
              </span>
              <span className="flex items-center justify-center">
                {NextArrowSVG}
              </span>
            </div>
          </Radio.Button>
        </Radio.Group>
      </Form.Item>

      <Form.Item className="w-full flex justify-center items-center mt-0 !mb-0">
        <button
          type="submit"
          className="rounded-full border-solid border-color-primary border-t-2 border-b-2 border-b-white border-r-2 border-l-2 border-l-white rotate-45 cursor-pointer bg-[#EEF0FF] w-14 h-14"
        >
          <IoIosArrowBack className="w-5 h-5 -rotate-45 text-color-primary" />
        </button>
      </Form.Item>
    </Form>
  );
};

export default Step25;
